import React from 'react';
import { Link } from 'react-router-dom';
import { FaStar } from 'react-icons/fa';
import { useCart } from '../context/CartContext';

function ProductCard({ product }) {
  const { addToCart } = useCart();

  return (
    <div className="product-card">
      <Link to={`/product/${product.id}`}>
        <img src={product.image} alt={product.name} className="product-image" />
      </Link>
      <div className="product-info">
        <Link to={`/product/${product.id}`}>
          <h3 className="product-name">{product.name}</h3>
        </Link>
        <div className="product-rating">
          {[...Array(5)].map((_, index) => (
            <FaStar
              key={index}
              color={index < Math.floor(product.rating) ? '#ffd700' : '#555'}
              size={16}
            />
          ))}
          <span> {product.rating}</span>
        </div>
        <p className="product-price">kr {product.price},-</p>
        <button
          className="product-button"
          onClick={() => addToCart(product)}
        >
          Legg i handlekurv
        </button>
      </div>
    </div>
  );
}

export default ProductCard;